import { Component, Input, OnInit } from '@angular/core';
import { NavigationItem } from '../../models/navigation-item.model';

@Component({
    selector: 'black-sub-navbar',
    templateUrl: './sub-navbar.component.html',
    styleUrls: ['./sub-navbar.component.css', './sub-navbar.component.scss'],
    standalone: false
})
export class SubNavbarComponent implements OnInit {
  constructor() {}

  @Input()
  menuItems:NavigationItem[] = [];

  @Input()
  title = '';

  ngOnInit(): void {}

}
